module.exports = __webpack_public_path__ + "static/img/logoImg.17da15a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/logoImg.png
// module id = oFVd
// module chunks = 83